(function () {
  if (typeof window === 'undefined') return;
  if (!('IntersectionObserver' in window)) {
    document.querySelectorAll('.reveal-up, .reveal-cards, .reveal-card').forEach(function (el) {
      el.classList.add('is-visible');
    });
    return;
  }

  var DESKTOP_MIN = 750;
  var isDesktop = function () {
    return window.matchMedia('(min-width: ' + DESKTOP_MIN + 'px)').matches;
  };

  var titleObserver = new IntersectionObserver(function (entries) {
    entries.forEach(function (entry) {
      if (entry.isIntersecting) {
        entry.target.classList.add('is-visible');
        titleObserver.unobserve(entry.target);
      }
    });
  }, { threshold: 0, rootMargin: '0px 0px -150px 0px' });

  var cardObserver = new IntersectionObserver(function (entries) {
    entries.forEach(function (entry) {
      if (entry.isIntersecting) {
        entry.target.classList.add('is-visible');
        cardObserver.unobserve(entry.target);
      }
    });
  }, { threshold: 0, rootMargin: '0px 0px -120px 0px' });

  var parentObserver = new IntersectionObserver(function (entries) {
    entries.forEach(function (entry) {
      if (entry.isIntersecting) {
        entry.target.classList.add('is-visible');
        parentObserver.unobserve(entry.target);
      }
    });
  }, { threshold: 0, rootMargin: '0px 0px -150px 0px' });

  function init() {
    document.querySelectorAll('.reveal-up:not(.is-visible)').forEach(function (el) {
      titleObserver.observe(el);
    });

    document.querySelectorAll('.reveal-cards').forEach(function (container) {
      if (isDesktop()) {
        parentObserver.observe(container);
      } else {
        container.querySelectorAll(':scope > .reveal-card:not(.is-visible)').forEach(function (card) {
          cardObserver.observe(card);
        });
      }
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  if (window.Shopify && window.Shopify.designMode) {
    document.addEventListener('shopify:section:load', init);
  }

  window.CustomReveal = { init: init };
})();
